var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "fields" }, [
        _c(
          "div",
          { staticClass: "eight wide required field" },
          [
            _c("label", [_vm._v("店舗名")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.model.name,
                  expression: "form.model.name",
                },
              ],
              attrs: { type: "text" },
              domProps: { value: _vm.form.model.name },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.form.model, "name", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c("validation-message", {
              attrs: { form: _vm.form, field: "name" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "eight wide required field" },
          [
            _c("label", [_vm._v("ヨミガナ")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.model.name_kana,
                  expression: "form.model.name_kana",
                },
              ],
              attrs: { type: "text" },
              domProps: { value: _vm.form.model.name_kana },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.form.model, "name_kana", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c("validation-message", {
              attrs: { form: _vm.form, field: "name_kana" },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "fields" }, [
        _c(
          "div",
          { staticClass: "eight wide field" },
          [
            _c("label", [_vm._v("店名修飾語")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.model.catchcopy,
                  expression: "form.model.catchcopy",
                },
              ],
              attrs: { type: "text" },
              domProps: { value: _vm.form.model.catchcopy },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.form.model, "catchcopy", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c("validation-message", {
              attrs: { form: _vm.form, field: "catchcopy" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _vm.isAdministrator || _vm.userRole === "shopadmin"
          ? _c(
              "div",
              { staticClass: "eight wide field" },
              [
                _c("label", [_vm._v("店長名(予約責任者名)")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.model.manager_name,
                      expression: "form.model.manager_name",
                    },
                  ],
                  attrs: { type: "text" },
                  domProps: { value: _vm.form.model.manager_name },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.form.model,
                        "manager_name",
                        $event.target.value
                      )
                    },
                  },
                }),
                _vm._v(" "),
                _c("validation-message", {
                  attrs: { form: _vm.form, field: "manager_name" },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.isAdministrator
        ? _c("basic-manage", { attrs: { form: _vm.form } })
        : _vm._e(),
      _vm._v(" "),
      _vm.isAdministrator || _vm.userRole === "shopadmin"
        ? _c("div", { staticClass: "fields" }, [
            _c(
              "div",
              { staticClass: "required eight wide field" },
              [
                _c("label", [_vm._v("メールアドレス")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.model.email,
                      expression: "form.model.email",
                    },
                  ],
                  attrs: { type: "text" },
                  domProps: { value: _vm.form.model.email },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.form.model, "email", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _c("validation-message", {
                  attrs: { form: _vm.form, field: "email" },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "eight wide field" },
              [
                _c("label", [
                  _vm._v("その他メールアドレス(カンマ区切りで複数指定可)"),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.model.secondary_email,
                      expression: "form.model.secondary_email",
                    },
                  ],
                  attrs: { type: "text" },
                  domProps: { value: _vm.form.model.secondary_email },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.form.model,
                        "secondary_email",
                        $event.target.value
                      )
                    },
                  },
                }),
                _vm._v(" "),
                _c("validation-message", {
                  attrs: { form: _vm.form, field: "secondary_email" },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isAdministrator || _vm.userRole === "afadmin"
        ? _c("div", { staticClass: "fields" }, [
            _c(
              "div",
              { staticClass: "required eight wide field" },
              [
                _c("label", [_vm._v("都道府県")]),
                _vm._v(" "),
                _c(
                  "dropdown",
                  {
                    attrs: { id: "prefecture", placeholder: "都道府県" },
                    model: {
                      value: _vm.form.model.prefecture,
                      callback: function ($$v) {
                        _vm.$set(_vm.form.model, "prefecture", $$v)
                      },
                      expression: "form.model.prefecture",
                    },
                  },
                  _vm._l(_vm.consts.SHOP_PREFECTURE, function (each) {
                    return _c(
                      "option",
                      {
                        key: each.label,
                        attrs: { disabled: each.value === "" },
                        domProps: { value: each.value },
                      },
                      [_vm._v(_vm._s(each.label))]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c("validation-message", {
                  attrs: { form: _vm.form, field: "prefecture" },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "required eight wide field" },
              [
                _c("label", [_vm._v("エリア")]),
                _vm._v(" "),
                _c(
                  "dropdown",
                  {
                    attrs: { placeholder: "エリア" },
                    on: {
                      change: function ($event) {
                        return _vm.onAreaChange()
                      },
                    },
                    model: {
                      value: _vm.form.model.area,
                      callback: function ($$v) {
                        _vm.$set(_vm.form.model, "area", $$v)
                      },
                      expression: "form.model.area",
                    },
                  },
                  _vm._l(_vm.areaOptions, function (each) {
                    return _c(
                      "option",
                      {
                        key: each.label,
                        attrs: { disabled: each.value === "" },
                        domProps: { value: each.value },
                      },
                      [_vm._v(_vm._s(each.label))]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c("validation-message", {
                  attrs: { form: _vm.form, field: "area" },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "required eight wide field" },
              [
                _c("label", [_vm._v("エリア詳細")]),
                _vm._v(" "),
                _c(
                  "dropdown",
                  {
                    ref: "areaDetail",
                    attrs: { placeholder: "エリア詳細" },
                    model: {
                      value: _vm.form.model.area_detail,
                      callback: function ($$v) {
                        _vm.$set(_vm.form.model, "area_detail", $$v)
                      },
                      expression: "form.model.area_detail",
                    },
                  },
                  [
                    _c("option", { attrs: { value: "" } }, [
                      _vm._v("エリア詳細"),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("validation-message", {
                  attrs: { form: _vm.form, field: "area_detail" },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "required eight wide field" },
              [
                _c("label", [_vm._v("最寄駅")]),
                _vm._v(" "),
                _c("dropdown", {
                  ref: "station",
                  attrs: { placeholder: "最寄駅", "key-prefix": "station_" },
                  on: {
                    change: function ($event) {
                      return _vm.onStationChange()
                    },
                  },
                  model: {
                    value: _vm.form.model.station,
                    callback: function ($$v) {
                      _vm.$set(_vm.form.model, "station", $$v)
                    },
                    expression: "form.model.station",
                  },
                }),
                _vm._v(" "),
                _c("validation-message", {
                  attrs: { form: _vm.form, field: "station" },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isAdministrator || _vm.userRole === "afadmin"
        ? _c(
            "div",
            { staticClass: "field" },
            [
              _c("label", [_vm._v("その他の最寄駅(複数選択可能)")]),
              _vm._v(" "),
              _c("dropdown", {
                ref: "otherStation",
                attrs: {
                  "max-size": -1,
                  placeholder: "その他の最寄駅",
                  "key-prefix": "other_stations_",
                },
                model: {
                  value: _vm.form.model.other_stations,
                  callback: function ($$v) {
                    _vm.$set(_vm.form.model, "other_stations", $$v)
                  },
                  expression: "form.model.other_stations",
                },
              }),
              _vm._v(" "),
              _c("validation-message", {
                attrs: { form: _vm.form, field: "other_stations" },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "required field" },
        [
          _c("label", [_vm._v("ジャンル(3つまで選択可能)")]),
          _vm._v(" "),
          _c("dropdown", {
            attrs: {
              options: _vm.consts.SHOP_GENRE,
              "max-size": 3,
              search: true,
              placeholder: "ジャンル",
            },
            model: {
              value: _vm.form.model.genres,
              callback: function ($$v) {
                _vm.$set(_vm.form.model, "genres", $$v)
              },
              expression: "form.model.genres",
            },
          }),
          _vm._v(" "),
          _c("validation-message", {
            attrs: { form: _vm.form, field: "genres" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "field" },
        [
          _c("label", [_vm._v("タグ")]),
          _vm._v(" "),
          _c(
            "dropdown",
            {
              attrs: { "max-size": -1, search: true, placeholder: "タグ" },
              model: {
                value: _vm.form.model.tags,
                callback: function ($$v) {
                  _vm.$set(_vm.form.model, "tags", $$v)
                },
                expression: "form.model.tags",
              },
            },
            _vm._l(_vm.consts.SHOP_TAGS, function (tag) {
              return _c("option", { domProps: { value: tag } }, [
                _vm._v(_vm._s(tag)),
              ])
            }),
            0
          ),
          _vm._v(" "),
          _c("validation-message", {
            attrs: { form: _vm.form, field: "tags" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "field" },
        [
          _c("label", [_vm._v("利用シーン")]),
          _vm._v(" "),
          _c(
            "dropdown",
            {
              attrs: {
                "max-size": -1,
                search: true,
                placeholder: "利用シーン",
              },
              model: {
                value: _vm.form.model.scenes,
                callback: function ($$v) {
                  _vm.$set(_vm.form.model, "scenes", $$v)
                },
                expression: "form.model.scenes",
              },
            },
            _vm._l(_vm.consts.SHOP_SCENES, function (scene) {
              return _c("option", { domProps: { value: scene } }, [
                _vm._v(_vm._s(scene)),
              ])
            }),
            0
          ),
          _vm._v(" "),
          _c("validation-message", {
            attrs: { form: _vm.form, field: "scenes" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "field" },
        [
          _c("label", [_vm._v("こだわり")]),
          _vm._v(" "),
          _c(
            "dropdown",
            {
              attrs: { "max-size": -1, search: true, placeholder: "こだわり" },
              model: {
                value: _vm.form.model.features,
                callback: function ($$v) {
                  _vm.$set(_vm.form.model, "features", $$v)
                },
                expression: "form.model.features",
              },
            },
            _vm._l(_vm.consts.SHOP_FEATURES, function (feature) {
              return _c("option", { domProps: { value: feature } }, [
                _vm._v(_vm._s(feature)),
              ])
            }),
            0
          ),
          _vm._v(" "),
          _c("validation-message", {
            attrs: { form: _vm.form, field: "features" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "fields" }, [
        _c(
          "div",
          { staticClass: "required eight wide field" },
          [
            _c("label", [_vm._v("電話番号")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.model.tel,
                  expression: "form.model.tel",
                },
              ],
              attrs: { type: "text" },
              domProps: { value: _vm.form.model.tel },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.form.model, "tel", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "caption" }, [
              _vm._v("半角数字のみ入力"),
            ]),
            _vm._v(" "),
            _c("validation-message", {
              attrs: { form: _vm.form, field: "tel" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "eight wide field" },
          [
            _c("label", [_vm._v("FAX番号")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.model.fax,
                  expression: "form.model.fax",
                },
              ],
              attrs: { type: "text" },
              domProps: { value: _vm.form.model.fax },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.form.model, "fax", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "caption" }, [
              _vm._v("半角数字のみ入力"),
            ]),
            _vm._v(" "),
            _c("validation-message", {
              attrs: { form: _vm.form, field: "fax" },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.isAdministrator
        ? _c(
            "div",
            { staticClass: "field" },
            [
              _c("label", [_vm._v("Twilio電話番号")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.model.twilio_tel,
                    expression: "form.model.twilio_tel",
                  },
                ],
                attrs: { type: "text" },
                domProps: { value: _vm.form.model.twilio_tel },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.form.model, "twilio_tel", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "caption" }, [
                _vm._v("半角数字のみ入力"),
              ]),
              _vm._v(" "),
              _c("validation-message", {
                attrs: { form: _vm.form, field: "twilio_tel" },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isAdministrator || _vm.userRole === "afadmin"
        ? _c("div", { staticClass: "fields" }, [
            _c("div", { staticClass: "eight field" }, [
              _c("label", [_vm._v("都道府県")]),
              _vm._v(" "),
              _c("input", {
                attrs: { type: "text", disabled: "" },
                domProps: { value: _vm.selectedPrefectureName },
              }),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "eight field" },
              [
                _c("label", [_vm._v("市区町村")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.model.city,
                      expression: "form.model.city",
                    },
                  ],
                  attrs: { type: "text", placeholder: "新宿区" },
                  domProps: { value: _vm.form.model.city },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.form.model, "city", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _c("validation-message", {
                  attrs: { form: _vm.form, field: "city" },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "eight wide field" },
              [
                _c("label", [_vm._v("それ以降の住所")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.model.address_detail,
                      expression: "form.model.address_detail",
                    },
                  ],
                  attrs: { type: "text", placeholder: "中町1-2-3" },
                  domProps: { value: _vm.form.model.address_detail },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.form.model,
                        "address_detail",
                        $event.target.value
                      )
                    },
                  },
                }),
                _vm._v(" "),
                _c("validation-message", {
                  attrs: { form: _vm.form, field: "address_detail" },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "eight wide field" },
              [
                _c("label", [_vm._v("建物名・フロア")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.model.address2,
                      expression: "form.model.address2",
                    },
                  ],
                  attrs: { type: "text" },
                  domProps: { value: _vm.form.model.address2 },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.form.model, "address2", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _c("validation-message", {
                  attrs: { form: _vm.form, field: "address2" },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "fields" }, [
        _c(
          "div",
          { staticClass: "required eight wide field" },
          [
            _c("label", [_vm._v("住所")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.model.address,
                  expression: "form.model.address",
                },
              ],
              attrs: { type: "text" },
              domProps: { value: _vm.form.model.address },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.form.model, "address", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c("validation-message", {
              attrs: { form: _vm.form, field: "address" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        !_vm.isAdministrator && _vm.userRole !== "afadmin"
          ? _c(
              "div",
              { staticClass: "eight wide field" },
              [
                _c("label", [_vm._v("建物名・フロア")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.model.address2,
                      expression: "form.model.address2",
                    },
                  ],
                  attrs: { type: "text" },
                  domProps: { value: _vm.form.model.address2 },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.form.model, "address2", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _c("validation-message", {
                  attrs: { form: _vm.form, field: "address2" },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "required field" },
        [
          _c("label", [_vm._v("アクセス")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.model.access,
                expression: "form.model.access",
              },
            ],
            attrs: { type: "text", placeholder: "例：○○駅前徒歩5分" },
            domProps: { value: _vm.form.model.access },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.form.model, "access", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _c("validation-message", {
            attrs: { form: _vm.form, field: "access" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "required field" },
        [
          _c("label", [_vm._v("営業時間")]),
          _vm._v(" "),
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.model.opening_hours,
                expression: "form.model.opening_hours",
              },
            ],
            attrs: {
              rows: "2",
              placeholder:
                "例：月～木:11:00－22:00 (L.O 21:30) 土日祝 10:00～23:00 (L.O 22:30)",
            },
            domProps: { value: _vm.form.model.opening_hours },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.form.model, "opening_hours", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _c("validation-message", {
            attrs: { form: _vm.form, field: "opening_hours" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "required field" },
        [
          _c("label", [_vm._v("定休日")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.model.holiday,
                expression: "form.model.holiday",
              },
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.form.model.holiday },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.form.model, "holiday", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _c("validation-message", {
            attrs: { form: _vm.form, field: "holiday" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "field" },
        [
          _c("label", [_vm._v("会場タイプ")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "fields" },
            _vm._l(_vm.consts.SHOP_TYPE, function (shopType) {
              return _c("div", { key: shopType.value, staticClass: "field" }, [
                _c("div", { staticClass: "ui checkbox radio" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.model.shop_type,
                        expression: "form.model.shop_type",
                      },
                    ],
                    attrs: { type: "radio", name: "shop_type" },
                    domProps: {
                      value: shopType.value,
                      checked: _vm._q(_vm.form.model.shop_type, shopType.value),
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$set(
                          _vm.form.model,
                          "shop_type",
                          shopType.value
                        )
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("label", [_vm._v(_vm._s(shopType.label))]),
                ]),
              ])
            }),
            0
          ),
          _vm._v(" "),
          _c("validation-message", {
            attrs: { form: _vm.form, field: "shop_type" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "fields" }, [
        _c("div", { staticClass: "four wide field" }, [
          _c("label", [_vm._v("座席数")]),
          _vm._v(" "),
          _c("div", { staticClass: "ui right labeled input" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.model.max_seat_count,
                  expression: "form.model.max_seat_count",
                },
              ],
              attrs: { type: "number", placeholder: "100" },
              domProps: { value: _vm.form.model.max_seat_count },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(
                    _vm.form.model,
                    "max_seat_count",
                    $event.target.value
                  )
                },
              },
            }),
            _vm._v(" "),
            _c("label", { staticClass: "ui label" }, [_vm._v("席")]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "four wide field" }, [
          _c("label", [_vm._v("個室数(会場数) 20名以上")]),
          _vm._v(" "),
          _c("div", { staticClass: "ui right labeled input" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.model.room_count,
                  expression: "form.model.room_count",
                },
              ],
              attrs: { type: "number", placeholder: "100" },
              domProps: { value: _vm.form.model.room_count },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.form.model, "room_count", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c("label", { staticClass: "ui label" }, [_vm._v("室")]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "four wide field" }, [
          _c("label", [_vm._v("最大着席人数")]),
          _vm._v(" "),
          _c("div", { staticClass: "ui right labeled input" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.model.max_count,
                  expression: "form.model.max_count",
                },
              ],
              attrs: { type: "number", placeholder: "100" },
              domProps: { value: _vm.form.model.max_count },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.form.model, "max_count", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c("label", { staticClass: "ui label" }, [_vm._v("人")]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "four wide field" }, [
          _c("label", [_vm._v("最大立食人数")]),
          _vm._v(" "),
          _c("div", { staticClass: "ui right labeled input" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.model.max_standing_count,
                  expression: "form.model.max_standing_count",
                },
              ],
              attrs: { type: "number", placeholder: "100" },
              domProps: { value: _vm.form.model.max_standing_count },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(
                    _vm.form.model,
                    "max_standing_count",
                    $event.target.value
                  )
                },
              },
            }),
            _vm._v(" "),
            _c("label", { staticClass: "ui label" }, [_vm._v("人")]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "field" }, [
        _c("label", [_vm._v("貸切")]),
        _vm._v(" "),
        _c("div", { staticClass: "fields" }, [
          _c("div", { staticClass: "field" }, [
            _c("div", { staticClass: "ui checkbox radio" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.model.can_reserve,
                    expression: "form.model.can_reserve",
                  },
                ],
                attrs: { type: "radio", name: "can_reserve", value: "true" },
                domProps: {
                  checked: _vm._q(_vm.form.model.can_reserve, "true"),
                },
                on: {
                  change: function ($event) {
                    return _vm.$set(_vm.form.model, "can_reserve", "true")
                  },
                },
              }),
              _vm._v(" "),
              _c("label", [_vm._v("可")]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "field" }, [
            _c("div", { staticClass: "ui checkbox radio" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.model.can_reserve,
                    expression: "form.model.can_reserve",
                  },
                ],
                attrs: { type: "radio", name: "can_reserve" },
                domProps: {
                  value: false,
                  checked: _vm._q(_vm.form.model.can_reserve, false),
                },
                on: {
                  change: function ($event) {
                    return _vm.$set(_vm.form.model, "can_reserve", false)
                  },
                },
              }),
              _vm._v(" "),
              _c("label", [_vm._v("不可")]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "grouped fields" }, [
        _c("label", [_vm._v("支払方法")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "field" },
          [
            _c("checkbox-group", {
              attrs: { options: _vm.consts.PAYMENT },
              model: {
                value: _vm.form.model.payment,
                callback: function ($$v) {
                  _vm.$set(_vm.form.model, "payment", $$v)
                },
                expression: "form.model.payment",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "field" },
        [
          _c("label", [_vm._v("クレジットカード")]),
          _vm._v(" "),
          _c("dropdown", {
            attrs: { options: _vm.consts.CREDIT_CARD, "max-size": -1 },
            model: {
              value: _vm.form.model.credit_cards,
              callback: function ($$v) {
                _vm.$set(_vm.form.model, "credit_cards", $$v)
              },
              expression: "form.model.credit_cards",
            },
          }),
          _vm._v(" "),
          _c("validation-message", {
            attrs: { form: _vm.form, field: "credit_cards" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "required field" },
        [
          _c("label", [_vm._v("店舗TOP 見出し")]),
          _vm._v(" "),
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.model.title,
                expression: "form.model.title",
              },
            ],
            attrs: { rows: "4" },
            domProps: { value: _vm.form.model.title },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.form.model, "title", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _c("span", { staticClass: "caption" }, [
            _vm._v(
              _vm._s(_vm._f("length")(_vm.form.model.title)) + " / 200 文字"
            ),
          ]),
          _vm._v(" "),
          _c("validation-message", {
            attrs: { form: _vm.form, field: "title" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "required fields" }, [
        _c(
          "div",
          { staticClass: "required four wide field" },
          [
            _c("label", [_vm._v("店舗TOP 画像")]),
            _vm._v(" "),
            _c("s3", {
              model: {
                value: _vm.form.model.main_image,
                callback: function ($$v) {
                  _vm.$set(_vm.form.model, "main_image", $$v)
                },
                expression: "form.model.main_image",
              },
            }),
            _vm._v(" "),
            _c("validation-message", {
              attrs: { form: _vm.form, field: "main_image" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "five wide field" },
          [
            _c("label", [_vm._v("店舗TOP PR文")]),
            _vm._v(" "),
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.model.main_image_title,
                  expression: "form.model.main_image_title",
                },
              ],
              attrs: { rows: "4" },
              domProps: { value: _vm.form.model.main_image_title },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(
                    _vm.form.model,
                    "main_image_title",
                    $event.target.value
                  )
                },
              },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "caption" }, [
              _vm._v(
                _vm._s(_vm._f("length")(_vm.form.model.main_image_title)) +
                  " / 200 文字"
              ),
            ]),
            _vm._v(" "),
            _c("validation-message", {
              attrs: { form: _vm.form, field: "main_image_title" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "required seven wide field" },
          [
            _c("label", [_vm._v("店舗TOP 詳細文")]),
            _vm._v(" "),
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.model.main_image_contents,
                  expression: "form.model.main_image_contents",
                },
              ],
              attrs: { rows: "4" },
              domProps: { value: _vm.form.model.main_image_contents },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(
                    _vm.form.model,
                    "main_image_contents",
                    $event.target.value
                  )
                },
              },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "caption" }, [
              _vm._v(
                _vm._s(_vm._f("length")(_vm.form.model.main_image_contents)) +
                  " / 500 文字"
              ),
            ]),
            _vm._v(" "),
            _c("validation-message", {
              attrs: { form: _vm.form, field: "main_image_contents" },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "fields" }, [
        _c(
          "div",
          { staticClass: "four wide field" },
          [
            _c("label", [_vm._v("店舗TOP サブ画像")]),
            _vm._v(" "),
            _c("s3", {
              model: {
                value: _vm.form.model.sub_image,
                callback: function ($$v) {
                  _vm.$set(_vm.form.model, "sub_image", $$v)
                },
                expression: "form.model.sub_image",
              },
            }),
            _vm._v(" "),
            _c("validation-message", {
              attrs: { form: _vm.form, field: "sub_image" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "five wide field" },
          [
            _c("label", [_vm._v("店舗TOP サブPR文")]),
            _vm._v(" "),
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.model.sub_image_title,
                  expression: "form.model.sub_image_title",
                },
              ],
              attrs: { rows: "4" },
              domProps: { value: _vm.form.model.sub_image_title },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(
                    _vm.form.model,
                    "sub_image_title",
                    $event.target.value
                  )
                },
              },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "caption" }, [
              _vm._v(
                _vm._s(_vm._f("length")(_vm.form.model.sub_image_title)) +
                  " / 200 文字"
              ),
            ]),
            _vm._v(" "),
            _c("validation-message", {
              attrs: { form: _vm.form, field: "sub_image_title" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "seven wide field" },
          [
            _c("label", [_vm._v("店舗TOP サブ詳細文")]),
            _vm._v(" "),
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.model.sub_image_contents,
                  expression: "form.model.sub_image_contents",
                },
              ],
              attrs: { rows: "4" },
              domProps: { value: _vm.form.model.sub_image_contents },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(
                    _vm.form.model,
                    "sub_image_contents",
                    $event.target.value
                  )
                },
              },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "caption" }, [
              _vm._v(
                _vm._s(_vm._f("length")(_vm.form.model.sub_image_contents)) +
                  " / 500 文字"
              ),
            ]),
            _vm._v(" "),
            _c("validation-message", {
              attrs: { form: _vm.form, field: "sub_image_contents" },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "fields" }, [
        _c(
          "div",
          { staticClass: "four wide field" },
          [
            _c("label", [_vm._v("店舗TOP サブ画像2")]),
            _vm._v(" "),
            _c("s3", {
              model: {
                value: _vm.form.model.sub_image2,
                callback: function ($$v) {
                  _vm.$set(_vm.form.model, "sub_image2", $$v)
                },
                expression: "form.model.sub_image2",
              },
            }),
            _vm._v(" "),
            _c("validation-message", {
              attrs: { form: _vm.form, field: "sub_image2" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "five wide field" },
          [
            _c("label", [_vm._v("店舗TOP サブPR文2")]),
            _vm._v(" "),
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.model.sub_image_title2,
                  expression: "form.model.sub_image_title2",
                },
              ],
              attrs: { rows: "4" },
              domProps: { value: _vm.form.model.sub_image_title2 },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(
                    _vm.form.model,
                    "sub_image_title2",
                    $event.target.value
                  )
                },
              },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "caption" }, [
              _vm._v(
                _vm._s(_vm._f("length")(_vm.form.model.sub_image_title2)) +
                  " / 200 文字"
              ),
            ]),
            _vm._v(" "),
            _c("validation-message", {
              attrs: { form: _vm.form, field: "sub_image_title2" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "seven wide field" },
          [
            _c("label", [_vm._v("店舗TOP サブ詳細文2")]),
            _vm._v(" "),
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.model.sub_image_contents2,
                  expression: "form.model.sub_image_contents2",
                },
              ],
              attrs: { rows: "4" },
              domProps: { value: _vm.form.model.sub_image_contents2 },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(
                    _vm.form.model,
                    "sub_image_contents2",
                    $event.target.value
                  )
                },
              },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "caption" }, [
              _vm._v(
                _vm._s(_vm._f("length")(_vm.form.model.sub_image_contents2)) +
                  " / 500 文字"
              ),
            ]),
            _vm._v(" "),
            _c("validation-message", {
              attrs: { form: _vm.form, field: "sub_image_contents2" },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "fields" }, [
        _c(
          "div",
          { staticClass: "eight wide field" },
          [
            _c("label", [_vm._v("サブコンテンツ見出し1")]),
            _vm._v(" "),
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.model.sub_heading_title1,
                  expression: "form.model.sub_heading_title1",
                },
              ],
              attrs: { rows: "4" },
              domProps: { value: _vm.form.model.sub_heading_title1 },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(
                    _vm.form.model,
                    "sub_heading_title1",
                    $event.target.value
                  )
                },
              },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "caption" }, [
              _vm._v(
                _vm._s(_vm._f("length")(_vm.form.model.sub_heading_title1)) +
                  " / 200 文字"
              ),
            ]),
            _vm._v(" "),
            _c("validation-message", {
              attrs: { form: _vm.form, field: "sub_heading_title1" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "eight wide field" },
          [
            _c("label", [_vm._v("サブコンテンツ文章1")]),
            _vm._v(" "),
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.model.sub_heading_contents1,
                  expression: "form.model.sub_heading_contents1",
                },
              ],
              attrs: { rows: "4" },
              domProps: { value: _vm.form.model.sub_heading_contents1 },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(
                    _vm.form.model,
                    "sub_heading_contents1",
                    $event.target.value
                  )
                },
              },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "caption" }, [
              _vm._v(
                _vm._s(_vm._f("length")(_vm.form.model.sub_heading_contents1)) +
                  " / 500 文字"
              ),
            ]),
            _vm._v(" "),
            _c("validation-message", {
              attrs: { form: _vm.form, field: "sub_heading_contents1" },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "fields" }, [
        _c(
          "div",
          { staticClass: "eight wide field" },
          [
            _c("label", [_vm._v("サブコンテンツ見出し2")]),
            _vm._v(" "),
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.model.sub_heading_title2,
                  expression: "form.model.sub_heading_title2",
                },
              ],
              attrs: { rows: "4" },
              domProps: { value: _vm.form.model.sub_heading_title2 },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(
                    _vm.form.model,
                    "sub_heading_title2",
                    $event.target.value
                  )
                },
              },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "caption" }, [
              _vm._v(
                _vm._s(_vm._f("length")(_vm.form.model.sub_heading_title2)) +
                  " / 200 文字"
              ),
            ]),
            _vm._v(" "),
            _c("validation-message", {
              attrs: { form: _vm.form, field: "sub_heading_title2" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "eight wide field" },
          [
            _c("label", [_vm._v("サブコンテンツ文章2")]),
            _vm._v(" "),
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.model.sub_heading_contents2,
                  expression: "form.model.sub_heading_contents2",
                },
              ],
              attrs: { rows: "4" },
              domProps: { value: _vm.form.model.sub_heading_contents2 },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(
                    _vm.form.model,
                    "sub_heading_contents2",
                    $event.target.value
                  )
                },
              },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "caption" }, [
              _vm._v(
                _vm._s(_vm._f("length")(_vm.form.model.sub_heading_contents2)) +
                  " / 500 文字"
              ),
            ]),
            _vm._v(" "),
            _c("validation-message", {
              attrs: { form: _vm.form, field: "sub_heading_contents2" },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "fields" }, [
        _c(
          "div",
          { staticClass: "eight wide field" },
          [
            _c("label", [_vm._v("サブコンテンツ見出し3")]),
            _vm._v(" "),
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.model.sub_heading_title3,
                  expression: "form.model.sub_heading_title3",
                },
              ],
              attrs: { rows: "4" },
              domProps: { value: _vm.form.model.sub_heading_title3 },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(
                    _vm.form.model,
                    "sub_heading_title3",
                    $event.target.value
                  )
                },
              },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "caption" }, [
              _vm._v(
                _vm._s(_vm._f("length")(_vm.form.model.sub_heading_title3)) +
                  " / 200 文字"
              ),
            ]),
            _vm._v(" "),
            _c("validation-message", {
              attrs: { form: _vm.form, field: "sub_heading_title3" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "eight wide field" },
          [
            _c("label", [_vm._v("サブコンテンツ文章3")]),
            _vm._v(" "),
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.model.sub_heading_contents3,
                  expression: "form.model.sub_heading_contents3",
                },
              ],
              attrs: { rows: "4" },
              domProps: { value: _vm.form.model.sub_heading_contents3 },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(
                    _vm.form.model,
                    "sub_heading_contents3",
                    $event.target.value
                  )
                },
              },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "caption" }, [
              _vm._v(
                _vm._s(_vm._f("length")(_vm.form.model.sub_heading_contents3)) +
                  " / 500 文字"
              ),
            ]),
            _vm._v(" "),
            _c("validation-message", {
              attrs: { form: _vm.form, field: "sub_heading_contents3" },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "fields" }, [
        _c(
          "div",
          { staticClass: "eight wide field" },
          [
            _c("label", [_vm._v("サブコンテンツ見出し4")]),
            _vm._v(" "),
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.model.sub_heading_title4,
                  expression: "form.model.sub_heading_title4",
                },
              ],
              attrs: { rows: "4" },
              domProps: { value: _vm.form.model.sub_heading_title4 },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(
                    _vm.form.model,
                    "sub_heading_title4",
                    $event.target.value
                  )
                },
              },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "caption" }, [
              _vm._v(
                _vm._s(_vm._f("length")(_vm.form.model.sub_heading_title4)) +
                  " / 200 文字"
              ),
            ]),
            _vm._v(" "),
            _c("validation-message", {
              attrs: { form: _vm.form, field: "sub_heading_title4" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "eight wide field" },
          [
            _c("label", [_vm._v("サブコンテンツ文章4")]),
            _vm._v(" "),
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.model.sub_heading_contents4,
                  expression: "form.model.sub_heading_contents4",
                },
              ],
              attrs: { rows: "4" },
              domProps: { value: _vm.form.model.sub_heading_contents4 },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(
                    _vm.form.model,
                    "sub_heading_contents4",
                    $event.target.value
                  )
                },
              },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "caption" }, [
              _vm._v(
                _vm._s(_vm._f("length")(_vm.form.model.sub_heading_contents4)) +
                  " / 500 文字"
              ),
            ]),
            _vm._v(" "),
            _c("validation-message", {
              attrs: { form: _vm.form, field: "sub_heading_contents4" },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "fields" }, [
        _c(
          "div",
          { staticClass: "eight wide field" },
          [
            _c("label", [_vm._v("サブコンテンツ見出し5")]),
            _vm._v(" "),
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.model.sub_heading_title5,
                  expression: "form.model.sub_heading_title5",
                },
              ],
              attrs: { rows: "4" },
              domProps: { value: _vm.form.model.sub_heading_title5 },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(
                    _vm.form.model,
                    "sub_heading_title5",
                    $event.target.value
                  )
                },
              },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "caption" }, [
              _vm._v(
                _vm._s(_vm._f("length")(_vm.form.model.sub_heading_title5)) +
                  " / 200 文字"
              ),
            ]),
            _vm._v(" "),
            _c("validation-message", {
              attrs: { form: _vm.form, field: "sub_heading_title5" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "eight wide field" },
          [
            _c("label", [_vm._v("サブコンテンツ文章5")]),
            _vm._v(" "),
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.model.sub_heading_contents5,
                  expression: "form.model.sub_heading_contents5",
                },
              ],
              attrs: { rows: "4" },
              domProps: { value: _vm.form.model.sub_heading_contents5 },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(
                    _vm.form.model,
                    "sub_heading_contents5",
                    $event.target.value
                  )
                },
              },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "caption" }, [
              _vm._v(
                _vm._s(_vm._f("length")(_vm.form.model.sub_heading_contents5)) +
                  " / 500 文字"
              ),
            ]),
            _vm._v(" "),
            _c("validation-message", {
              attrs: { form: _vm.form, field: "sub_heading_contents5" },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "fields" }, [
        _c(
          "div",
          { staticClass: "eight wide field" },
          [
            _c("label", [_vm._v("サブコンテンツ見出し6")]),
            _vm._v(" "),
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.model.sub_heading_title6,
                  expression: "form.model.sub_heading_title6",
                },
              ],
              attrs: { rows: "4" },
              domProps: { value: _vm.form.model.sub_heading_title6 },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(
                    _vm.form.model,
                    "sub_heading_title6",
                    $event.target.value
                  )
                },
              },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "caption" }, [
              _vm._v(
                _vm._s(_vm._f("length")(_vm.form.model.sub_heading_title6)) +
                  " / 200 文字"
              ),
            ]),
            _vm._v(" "),
            _c("validation-message", {
              attrs: { form: _vm.form, field: "sub_heading_title6" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "eight wide field" },
          [
            _c("label", [_vm._v("サブコンテンツ文章6")]),
            _vm._v(" "),
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.model.sub_heading_contents6,
                  expression: "form.model.sub_heading_contents6",
                },
              ],
              attrs: { rows: "4" },
              domProps: { value: _vm.form.model.sub_heading_contents6 },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(
                    _vm.form.model,
                    "sub_heading_contents6",
                    $event.target.value
                  )
                },
              },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "caption" }, [
              _vm._v(
                _vm._s(_vm._f("length")(_vm.form.model.sub_heading_contents6)) +
                  " / 500 文字"
              ),
            ]),
            _vm._v(" "),
            _c("validation-message", {
              attrs: { form: _vm.form, field: "sub_heading_contents6" },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.userRole === "afadmin"
        ? _c(
            "div",
            { staticClass: "field" },
            [
              _c("label", [_vm._v("店舗レイアウト画像")]),
              _vm._v(" "),
              _c("s3", {
                model: {
                  value: _vm.form.model.layout_image,
                  callback: function ($$v) {
                    _vm.$set(_vm.form.model, "layout_image", $$v)
                  },
                  expression: "form.model.layout_image",
                },
              }),
              _vm._v(" "),
              _c("validation-message", {
                attrs: { form: _vm.form, field: "layout_image" },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "fields" }, [
        _c(
          "div",
          { staticClass: "four wide required field" },
          [
            _c("label", [_vm._v("喫煙")]),
            _vm._v(" "),
            _c(
              "dropdown",
              {
                attrs: { placeholder: "喫煙" },
                model: {
                  value: _vm.form.model.smoking_type,
                  callback: function ($$v) {
                    _vm.$set(_vm.form.model, "smoking_type", $$v)
                  },
                  expression: "form.model.smoking_type",
                },
              },
              _vm._l(_vm.consts.SMOKING, function (each) {
                return _c(
                  "option",
                  {
                    key: each.value,
                    attrs: { disabled: each.value === "" },
                    domProps: { value: each.value },
                  },
                  [_vm._v(_vm._s(each.label))]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c("validation-message", {
              attrs: { form: _vm.form, field: "smoking_type" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "ten wide field" },
          [
            _c("label", [_vm._v("備考")]),
            _vm._v(" "),
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.model.smoking_remarks,
                  expression: "form.model.smoking_remarks",
                },
              ],
              domProps: { value: _vm.form.model.smoking_remarks },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(
                    _vm.form.model,
                    "smoking_remarks",
                    $event.target.value
                  )
                },
              },
            }),
            _vm._v(" "),
            _c("validation-message", {
              attrs: { form: _vm.form, field: "smoking_remarks" },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "field" }, [
        _c("label", [_vm._v("昼宴会")]),
        _vm._v(" "),
        _c("div", { staticClass: "fields" }, [
          _c("div", { staticClass: "field" }, [
            _c("div", { staticClass: "ui checkbox radio" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.model.lunch_ok,
                    expression: "form.model.lunch_ok",
                  },
                ],
                attrs: { type: "radio", value: "true", name: "lunch_ok" },
                domProps: { checked: _vm._q(_vm.form.model.lunch_ok, "true") },
                on: {
                  change: function ($event) {
                    return _vm.$set(_vm.form.model, "lunch_ok", "true")
                  },
                },
              }),
              _vm._v(" "),
              _c("label", [_vm._v("可")]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "field" }, [
            _c("div", { staticClass: "ui checkbox radio" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.model.lunch_ok,
                    expression: "form.model.lunch_ok",
                  },
                ],
                attrs: { type: "radio", value: "false", name: "lunch_ok" },
                domProps: { checked: _vm._q(_vm.form.model.lunch_ok, "false") },
                on: {
                  change: function ($event) {
                    return _vm.$set(_vm.form.model, "lunch_ok", "false")
                  },
                },
              }),
              _vm._v(" "),
              _c("label", [_vm._v("不可")]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "field" }, [
        _c("label", [_vm._v("持込み")]),
        _vm._v(" "),
        _c("div", { staticClass: "fields" }, [
          _c("div", { staticClass: "field" }, [
            _c("div", { staticClass: "ui checkbox radio" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.model.bringing_ok,
                    expression: "form.model.bringing_ok",
                  },
                ],
                attrs: { type: "radio", value: "true", name: "bringing_ok" },
                domProps: {
                  checked: _vm._q(_vm.form.model.bringing_ok, "true"),
                },
                on: {
                  change: function ($event) {
                    return _vm.$set(_vm.form.model, "bringing_ok", "true")
                  },
                },
              }),
              _vm._v(" "),
              _c("label", [_vm._v("可")]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "field" }, [
            _c("div", { staticClass: "ui checkbox radio" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.model.bringing_ok,
                    expression: "form.model.bringing_ok",
                  },
                ],
                attrs: { type: "radio", value: "false", name: "bringing_ok" },
                domProps: {
                  checked: _vm._q(_vm.form.model.bringing_ok, "false"),
                },
                on: {
                  change: function ($event) {
                    return _vm.$set(_vm.form.model, "bringing_ok", "false")
                  },
                },
              }),
              _vm._v(" "),
              _c("label", [_vm._v("不可")]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "ten wide field" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.model.bringing_note,
                  expression: "form.model.bringing_note",
                },
              ],
              attrs: { type: "text", placeholder: "備考" },
              domProps: { value: _vm.form.model.bringing_note },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.form.model, "bringing_note", $event.target.value)
                },
              },
            }),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "field" },
        [
          _c("label", [_vm._v("店舗URL")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.model.shop_url,
                expression: "form.model.shop_url",
              },
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.form.model.shop_url },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.form.model, "shop_url", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _c("validation-message", {
            attrs: { form: _vm.form, field: "shop_url" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "field" },
        [
          _c("label", [_vm._v("引用元URL")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.model.source_url,
                expression: "form.model.source_url",
              },
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.form.model.source_url },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.form.model, "source_url", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _c("span", { staticClass: "caption" }, [
            _vm._v("非契約店舗のみ有効"),
          ]),
          _vm._v(" "),
          _c("validation-message", {
            attrs: { form: _vm.form, field: "source_url" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "field" },
        [
          _c("label", [_vm._v("プランURL")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.model.plan_url,
                expression: "form.model.plan_url",
              },
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.form.model.plan_url },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.form.model, "plan_url", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _c("span", { staticClass: "caption" }, [
            _vm._v("非契約店舗のみ有効"),
          ]),
          _vm._v(" "),
          _c("validation-message", {
            attrs: { form: _vm.form, field: "plan_url" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "field" },
        [
          _c("label", [_vm._v("360度ビューURL")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.model.street_view_url,
                expression: "form.model.street_view_url",
              },
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.form.model.street_view_url },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.form.model, "street_view_url", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _c("validation-message", {
            attrs: { form: _vm.form, field: "street_view_url" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "field" }, [
        _c("label", [_vm._v("キャンセル規定")]),
        _vm._v(" "),
        _c("textarea", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.model.cancellation_policy,
              expression: "form.model.cancellation_policy",
            },
          ],
          attrs: { rows: "3" },
          domProps: { value: _vm.form.model.cancellation_policy },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(
                _vm.form.model,
                "cancellation_policy",
                $event.target.value
              )
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "field" }, [
        _c("label", [_vm._v("最低保証金額")]),
        _vm._v(" "),
        _c("textarea", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.model.min_guarantee_amount,
              expression: "form.model.min_guarantee_amount",
            },
          ],
          attrs: { rows: "2" },
          domProps: { value: _vm.form.model.min_guarantee_amount },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(
                _vm.form.model,
                "min_guarantee_amount",
                $event.target.value
              )
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "field" }, [
        _c("label", [_vm._v("立候補通知メールを受信する")]),
        _vm._v(" "),
        _c("div", { staticClass: "fields" }, [
          _c("div", { staticClass: "field" }, [
            _c("div", { staticClass: "ui checkbox radio" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.model.candidate_mail_required,
                    expression: "form.model.candidate_mail_required",
                  },
                ],
                attrs: {
                  type: "radio",
                  value: "true",
                  name: "candidate_mail_required",
                },
                domProps: {
                  checked: _vm._q(
                    _vm.form.model.candidate_mail_required,
                    "true"
                  ),
                },
                on: {
                  change: function ($event) {
                    return _vm.$set(
                      _vm.form.model,
                      "candidate_mail_required",
                      "true"
                    )
                  },
                },
              }),
              _vm._v(" "),
              _c("label", [_vm._v("受信する")]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "field" }, [
            _c("div", { staticClass: "ui checkbox radio" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.model.candidate_mail_required,
                    expression: "form.model.candidate_mail_required",
                  },
                ],
                attrs: {
                  type: "radio",
                  value: "false",
                  name: "candidate_mail_required",
                },
                domProps: {
                  checked: _vm._q(
                    _vm.form.model.candidate_mail_required,
                    "false"
                  ),
                },
                on: {
                  change: function ($event) {
                    return _vm.$set(
                      _vm.form.model,
                      "candidate_mail_required",
                      "false"
                    )
                  },
                },
              }),
              _vm._v(" "),
              _c("label", [_vm._v("受信しない")]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "field" }, [
        _c("label", [_vm._v("自動生成QAコンテンツ")]),
        _vm._v(" "),
        _c("div", { staticClass: "fields" }, [
          _c("div", { staticClass: "field" }, [
            _c("div", { staticClass: "ui checkbox radio" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.model.faq_required,
                    expression: "form.model.faq_required",
                  },
                ],
                attrs: { type: "radio", value: "true", name: "faq_required" },
                domProps: {
                  checked: _vm._q(_vm.form.model.faq_required, "true"),
                },
                on: {
                  change: function ($event) {
                    return _vm.$set(_vm.form.model, "faq_required", "true")
                  },
                },
              }),
              _vm._v(" "),
              _c("label", [_vm._v("表示する")]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "field" }, [
            _c("div", { staticClass: "ui checkbox radio" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.model.faq_required,
                    expression: "form.model.faq_required",
                  },
                ],
                attrs: { type: "radio", value: "false", name: "faq_required" },
                domProps: {
                  checked: _vm._q(_vm.form.model.faq_required, "false"),
                },
                on: {
                  change: function ($event) {
                    return _vm.$set(_vm.form.model, "faq_required", "false")
                  },
                },
              }),
              _vm._v(" "),
              _c("label", [_vm._v("表示しない")]),
            ]),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }